import React from "react";
import POSDashboard from "../components/pos/pages/Dashboard";
import { CartProvider } from "../components/pos/contexts/cartContext";
import ProtectedRoute from "./ProtectedRoute";
import MainLayout from "../components/CommonComponents/MainLayout";
import TransactionList from "../components/transaction/TransactionList";
import POSProductsTable from "../components/pos/pages/POSProductsTable";
import { POSProductsProvider } from "../components/pos/contexts/POSProductContext";
// import RawMaterialsCatalogPage from "../pages/RawMaterialsCatalogPage"; // Disabled: Pre-release flow
import ProductionPage from "../components/pos/pages/ProductionPage";
import ProductionLogsPage from "../components/pos/pages/ProductionLogsPage";
import DisposalPage from "../components/pos/pages/DisposalPage";
import RawMaterialUsagePage from "../components/pos/pages/RawMaterialUsagePage";

// POS Routes
export const posRoutes = [
    {
        path: "/dashboard",
        element: (
            <ProtectedRoute allowedRoles={[2]} allowedRoleNames={["cashier", "manager"]}>
                <MainLayout>
                    <CartProvider>
                        <POSDashboard />
                    </CartProvider>
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/transactions",
        element: (
            <ProtectedRoute allowedRoles={[2]} allowedRoleNames={["cashier", "manager"]}>
                <MainLayout>
                    <TransactionList restrictToToday={true} />
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/raw-material-usage",
        element: (
            <ProtectedRoute allowedRoles={[2]} allowedRoleNames={["cashier", "manager"]}>
                <MainLayout>
                    <RawMaterialUsagePage />
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/products",
        element: (
            <ProtectedRoute allowedRoles={[2]} allowedRoleNames={["cashier", "manager"]}>
                <MainLayout>
                    <POSProductsProvider>
                        <CartProvider>
                            <div className="flex flex-col h-full">
                                <div className="flex-1 min-h-0 overflow-auto p-4">
                                    <POSProductsTable />
                                </div>
                            </div>
                        </CartProvider>
                    </POSProductsProvider>
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    // {
    //     path: "/pre-release",
    //     element: (
    //         <ProtectedRoute allowedRoles={[2]} allowedRoleNames={["cashier", "manager"]}>
    //             <MainLayout>
    //                 <React.Suspense fallback={<div>Loading...</div>}>
    //                     {React.createElement(require("../components/pos/pages/PreReleasePage.js").default)}
    //                 </React.Suspense>
    //             </MainLayout>
    //         </ProtectedRoute>
    //     ),
    // }, // Disabled: Pre-release flow
    // {
    //     path: "/raw-materials-catalog",
    //     element: (
    //         <ProtectedRoute allowedRoles={[2]} allowedRoleNames={["cashier", "manager"]}>
    //             <MainLayout>
    //                 <RawMaterialsCatalogPage />
    //             </MainLayout>
    //         </ProtectedRoute>
    //     ),
    // }, // Disabled: Pre-release flow
    {
        path: "/production",
        element: (
            <ProtectedRoute allowedRoles={[2]} allowedRoleNames={["cashier", "manager"]}>
                <MainLayout>
                    <ProductionPage />
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/production-logs",
        element: (
            <ProtectedRoute allowedRoles={[2]} allowedRoleNames={["cashier", "manager"]}>
                <MainLayout>
                    <ProductionLogsPage />
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/disposal",
        element: (
            <ProtectedRoute allowedRoles={[2]} allowedRoleNames={["cashier", "manager"]}>
                <MainLayout>
                    <DisposalPage />
                </MainLayout>
            </ProtectedRoute>
        ),
    },
];
